import api from "api";
import ApiCaller from "api/apiCaller";
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup
} from "reactstrap";
import DataPipelineConfiguration from 'model/data_pipeline_configuration';
import "./index.css";

interface PipelineConfigurationModal {
  isShow: boolean;
  onModalClose?: Function;
}

const defaultDataPipelineConfiguration:DataPipelineConfiguration = {
  gcs_schema_bucket: '',
  alert_channel_id: ''
}

const PipelineConfigurationModal = ({ isShow, onModalClose }:PipelineConfigurationModal) => {
  const companyId: any = api.getCurrentCompanyId();
  const [modal, setModal] = useState(isShow || false);
  const [dataPipelineConfiguration, setDataPipelineConfiguration] = useState<DataPipelineConfiguration>({
    ...defaultDataPipelineConfiguration,
  });
  const [alertChannels, setAlertChannels] = useState([]);
  const [isCreate, setIsCreate] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const toggle = () => {
    setModal(!modal);
  };
  const submitConfiguration = (event: any) => {
    setDataPipelineConfigurationAttr(event.target.name, event.target.value)
    saveConfiguration();
    toggle();
  };
  const getAlertChannels = async () => {
    const res:any = await ApiCaller.get(
      `datasource?company_id=${companyId}&is_active=1&include_types=alert_telegram`
    );
    if (res.data && res.data.datasources) {
      setAlertChannels(res.data.datasources);
    }
  };
  const getDataPipelineConfiguration = async () => {
    let uri = `pipeline/configuration?company_id=${companyId}`;
    const res:any = await ApiCaller.get(uri);
    if (res.data && res.data.data_pipeline_configuration) {
      setDataPipelineConfiguration(res.data.data_pipeline_configuration);
      setIsCreate(false);
      setIsSaving(true);
    }
  };
  const saveConfiguration = async () => {
    const method = dataPipelineConfiguration.id? 'put' : 'post';
    const uri = dataPipelineConfiguration.id? `pipeline/configuration/${dataPipelineConfiguration.id}` : 'pipeline/configuration'
    const res:any = await ApiCaller[method](`${uri}?company_id=${companyId}`, dataPipelineConfiguration)
    if (res.status === 'ok') {
      alert('Configuration has been set successfuly!')
    } else {
      alert(res.message)
    }
  }
  const setDataPipelineConfigurationAttr = (attr:string, value:any) => {
    setDataPipelineConfiguration({
      ...dataPipelineConfiguration,
      [attr]: value,
    });
  }
  useEffect(() => {
    if (!modal && onModalClose) {
      onModalClose();
    }
  }, [modal]);
  useEffect(() => {
    getDataPipelineConfiguration();
    getAlertChannels();
  }, []);

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>General Configuration for Data Pipelines</ModalHeader>
      <ModalBody>
      <FormGroup>
        <div className="form-group">
          <label>Schema GCS Bucket</label>
          <input
            id="gcs_schema_bucket"
            className="form-control"
            placeholder="GCS bucket where schema will be stored"
            value={dataPipelineConfiguration.gcs_schema_bucket || ''}
            onChange={e => setDataPipelineConfigurationAttr(e.target.id, e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Alert Channel</label>
          <select
            className="form-control"
            onChange={e => setDataPipelineConfigurationAttr('alert_channel_id', e.target.value)}
            value={dataPipelineConfiguration.alert_channel_id || ''}
          >
            <option value="" hidden>-- Select one --</option>
            {alertChannels.map((option:any) =>
              <option key={option.value || option.id} value={option.value || option.id}>
                {option.label || option.name}
              </option>
            )}
          </select>
        </div>
        <div className="form-group">
          <button 
            className="form-control btn btn-primary"
            type="submit"
            onClick={submitConfiguration}
          >
            Update
          </button>
        </div>
      </FormGroup>
      </ModalBody>
    </Modal>
  );
}

export default PipelineConfigurationModal;